<template>
    <v-card class="fill-height">
        <v-img class="align-end" height="250px" src="../../../assets/backgrounds/kings_residence.jpg">
            <v-card-title class="welcome">
                {{ getWelcomeMessage }}
            </v-card-title>
        </v-img>
        <v-card-text>
            <announcement :announcement="getIntroAnnouncement"></announcement>
        </v-card-text>
        <residence-terms :residenceTermsAppliedTo="residenceTermsAppliedTo"></residence-terms>
    </v-card>
</template>

<script>
import auth from '../../../js/auth';
import Announcement from './Announcement';
import ResidenceTerms from './ResidenceTerms';

export default {
    name: 'home-welcome',
    components: {
        Announcement,
        ResidenceTerms
    },
    props: {
        announcements: {
            required: true
        },
        residenceTermsAppliedTo: {
            required: true
        }
    },
    computed: {
        getIntroAnnouncement() {
            let announcement = {
                class: '',
                enabled: false,
                text: ''
            }

            for (let i = 0; i < this.announcements.length; i++) {
                if (this.announcements[i].hasOwnProperty('announcement-location') && this.announcements[i]['announcement-location'].match(/student/gi)) {
                    announcement.class = this.announcements[i]['announcement-class'];
                    announcement.enabled = this.announcements[i]['active'] == "1" ? true : announcement.enabled;
                    announcement.text = this.announcements[i]['announcement'];
                }
            }

            return announcement;
        },
        getWelcomeMessage() {
            let user = auth.getUser();
            let date = new Date();
            let hour = date.getHours();

            if (hour >= 12 && hour < 18) {
                return `Good afternoon, ${user.commonName}.`;
            } else if (hour >= 18 && hour < 24) {
                return `Good evening, ${user.commonName}.`;

            }

            return `Good morning, ${user.commonName}.`;
        }
    }
}
</script>

<style scoped>
.welcome {
    color: #fff !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: .0073529412em !important;
    word-break: normal;
}
</style>